/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { SystemIdentifierAccessCodeModelSearchResultModel } from '../../models/system-identifier-access-code-model-search-result-model';

export interface AdminSearchSystemIdentifierAccessCodePost$Params {
  
    /**
     * The search request model containing search parameters
     */
    body?: SearchRequestModel
}

export function adminSearchSystemIdentifierAccessCodePost(http: HttpClient, rootUrl: string, params?: AdminSearchSystemIdentifierAccessCodePost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<SystemIdentifierAccessCodeModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, adminSearchSystemIdentifierAccessCodePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<SystemIdentifierAccessCodeModelSearchResultModel>;
    })
  );
}

adminSearchSystemIdentifierAccessCodePost.PATH = '/Admin/SearchSystemIdentifierAccessCode';
